<template>
  <FadeInFromBottomTransition>
    <div
      v-show="isOpen"
      v-bind="$attrs"
      class="absolute left-0 z-30 hidden w-full md:block"
    >
      <FadeInTransition>
        <slot />
      </FadeInTransition>
    </div>
  </FadeInFromBottomTransition>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  isOpen: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})
</script>
